var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container pb-0" }, [
          _c(
            "div",
            { staticClass: "page-name" },
            [
              _vm._l(_vm.menu_data, function(menu, index) {
                return [
                  menu.name == _vm.company
                    ? [
                        _vm._v(
                          "\n                        " +
                            _vm._s(menu.name) +
                            "\n                    "
                        )
                      ]
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "internal-container contact-container" }, [
            _c(
              "div",
              { staticClass: "contacts-list-container" },
              [
                _vm._l(_vm.menu_data, function(menu, index) {
                  return [
                    menu.name == _vm.company
                      ? [
                          _vm._l(menu.locations, function(location, index1) {
                            return [
                              location.department_count > 0
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "contacts-block",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.gotoDepartmentList(
                                              _vm.company,
                                              location.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "contact-locations",
                                            attrs: { title: location.name }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.stringTrim(
                                                  location.name,
                                                  18
                                                )
                                              ) + " "
                                            ),
                                            _vm.windowWidth > 767
                                              ? _c(
                                                  "span",
                                                  {
                                                    class:
                                                      "pull-right contact-info-btn color-9cadb5 info_btn_location_" +
                                                      location.id,
                                                    attrs: {
                                                      title:
                                                        "Click to view details"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        $event.preventDefault()
                                                        return _vm.changelocationId(
                                                          location.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-info"
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "contact-details" },
                                          [
                                            _vm._v(
                                              _vm._s(location.address_line)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "contact-phone" },
                                          [
                                            location.contacts.length > 0
                                              ? [
                                                  location.contacts[0]
                                                    .contact_label != ""
                                                    ? [
                                                        _vm._v(
                                                          "\n                                                    " +
                                                            _vm._s(
                                                              location
                                                                .contacts[0]
                                                                .contact_label
                                                            ) +
                                                            " : "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  location.contacts[0]
                                                    .contact != ""
                                                    ? [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              location
                                                                .contacts[0]
                                                                .contact
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    : _vm._e()
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.windowWidth <= 767
                                          ? _c(
                                              "div",
                                              [
                                                location.note != "" ||
                                                location.address_line != "" ||
                                                location.contacts.length > 0
                                                  ? [
                                                      location.contacts.length >
                                                      1
                                                        ? [
                                                            _vm._l(
                                                              location.contacts,
                                                              function(
                                                                cont,
                                                                index2
                                                              ) {
                                                                return [
                                                                  index2 != 0
                                                                    ? [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "sidebar-locations-details mt-0 mb-0"
                                                                          },
                                                                          [
                                                                            cont.contact_label !=
                                                                            ""
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        cont.contact_label
                                                                                      ) +
                                                                                        " :"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              "\n                                                                " +
                                                                                _vm._s(
                                                                                  cont.contact
                                                                                ) +
                                                                                "\n                                                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            )
                                                          ]
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      location.note != ""
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sidebar-locations-details mt-0 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Note : " +
                                                                  _vm._s(
                                                                    location.note
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  : [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sidebar-locations-details mt-0 mb-0"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    " +
                                                              _vm._s(
                                                                _vm.noDataMessaage
                                                              ) +
                                                              "\n                                                "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                : [
                                    _c(
                                      "div",
                                      { staticClass: "contacts-block" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "contact-locations",
                                            attrs: { title: location.name }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.stringTrim(
                                                  location.name,
                                                  18
                                                )
                                              ) + " "
                                            ),
                                            _vm.windowWidth > 767
                                              ? _c(
                                                  "span",
                                                  {
                                                    class:
                                                      "pull-right contact-info-btn color-9cadb5 info_btn_location_" +
                                                      location.id,
                                                    attrs: {
                                                      title:
                                                        "Click to view details"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        $event.preventDefault()
                                                        return _vm.changelocationId(
                                                          location.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-info"
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "contact-details" },
                                          [
                                            _vm._v(
                                              _vm._s(location.address_line)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "contact-phone" },
                                          [
                                            location.contacts.length > 0
                                              ? [
                                                  location.contacts[0]
                                                    .contact_label != ""
                                                    ? [
                                                        _vm._v(
                                                          "\n                                                    " +
                                                            _vm._s(
                                                              location
                                                                .contacts[0]
                                                                .contact_label
                                                            ) +
                                                            " : "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  location.contacts[0]
                                                    .contact != ""
                                                    ? [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              location
                                                                .contacts[0]
                                                                .contact
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    : _vm._e()
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.windowWidth <= 767
                                          ? _c(
                                              "div",
                                              [
                                                location.note != "" ||
                                                location.address_line != "" ||
                                                location.contacts.length > 0
                                                  ? [
                                                      location.contacts.length >
                                                      1
                                                        ? [
                                                            _vm._l(
                                                              location.contacts,
                                                              function(
                                                                cont,
                                                                index2
                                                              ) {
                                                                return [
                                                                  index2 != 0
                                                                    ? [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "sidebar-locations-details mt-0 mb-0"
                                                                          },
                                                                          [
                                                                            cont.contact_label !=
                                                                            ""
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        cont.contact_label
                                                                                      ) +
                                                                                        " :"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              "\n                                                                " +
                                                                                _vm._s(
                                                                                  cont.contact
                                                                                ) +
                                                                                "\n                                                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            )
                                                          ]
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      location.note != ""
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sidebar-locations-details mt-0 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Note : " +
                                                                  _vm._s(
                                                                    location.note
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  : [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sidebar-locations-details mt-0 mb-0"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    " +
                                                              _vm._s(
                                                                _vm.noDataMessaage
                                                              ) +
                                                              "\n                                                "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                            ]
                          })
                        ]
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _vm.windowWidth > 767
          ? _c("div", { staticClass: "page-sidebar" }, [
              _c(
                "div",
                {
                  staticClass: "contactInfoBtn",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.showContact(_vm.company, _vm.locationId)
                    }
                  }
                },
                [_c("i", { staticClass: "openCloseBtn fa fa-caret-right" })]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "contactDetails" },
                [
                  _vm._l(_vm.menu_data, function(menu, index) {
                    return [
                      menu.name == _vm.company
                        ? [
                            _vm._l(menu.locations, function(location, index1) {
                              return [
                                location.id == _vm.locationId
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "sidebar-locations" },
                                        [_vm._v(_vm._s(location.name))]
                                      ),
                                      _vm._v(" "),
                                      location.note != "" ||
                                      location.address_line != "" ||
                                      location.contacts.length > 0
                                        ? [
                                            location.address_line != ""
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "sidebar-locations-details"
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          "/static/images/map-pin.png"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          location.address_line
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            location.note != ""
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "sidebar-locations-details mt-0"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        Note : " +
                                                        _vm._s(location.note) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            location.contacts.length > 0
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "primary-contact"
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                location
                                                                  .contacts[0]
                                                                  .contact_label !=
                                                                "",
                                                              expression:
                                                                "location.contacts[0].contact_label != ''"
                                                            }
                                                          ]
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                " +
                                                              _vm._s(
                                                                location
                                                                  .contacts[0]
                                                                  .contact_label
                                                              ) +
                                                              " :\n                                            "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            location.contacts[0]
                                                              .contact
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            location.contacts.length > 1
                                              ? [
                                                  _c(
                                                    "ul",
                                                    [
                                                      _vm._l(
                                                        location.contacts,
                                                        function(cont, index2) {
                                                          return [
                                                            index2 != 0
                                                              ? [
                                                                  _c("li", [
                                                                    cont.contact_label !=
                                                                    ""
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                cont.contact_label
                                                                              ) +
                                                                                " :"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(
                                                                      "\n                                                        " +
                                                                        _vm._s(
                                                                          cont.contact
                                                                        ) +
                                                                        "\n                                                    "
                                                                    )
                                                                  ])
                                                                ]
                                                              : _vm._e()
                                                          ]
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "sidebar-locations-details"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(_vm.noDataMessaage) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                    ]
                                  : _vm._e()
                              ]
                            })
                          ]
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d4ce7a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d4ce7a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/contactextension/ViewLocationDepartments.vue
// module id = null
// module chunks = 